import { Outlet } from 'react-router-dom';

import { useIsMigrated } from '@/hooks/use-migration';

import Sidebar from '../sidebar';

export default function SidebarLayout() {
  const isMigrated = useIsMigrated();

  return (
    <div className="flex h-full">
      {!isMigrated && <Sidebar />}
      <div className="h-full flex-1">
        <Outlet />
      </div>
    </div>
  );
}
